module.exports = __webpack_public_path__ + "assets/5e9d1d3eb3888cc966690cece880f23d.png";